import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
declare var getHexAscii: any;

@Component({
  selector: 'app-mini-statment-of-account',
  templateUrl: './mini-statment-of-account.component.html',
  styleUrls: ['./mini-statment-of-account.component.css']
})
export class MiniStatmentOfAccountComponent implements OnInit {
  scoAccounts: any;
  scoAndLoanAccounts :any;
  accountDigit :any;
  nickName: string;
  page1 : string ='';
  statementOfAccountList : any =[];
  //AccountList : any =[];
  AccountSelect : any;
  Accountbalance : any;
  Accountmodule : any;
  AccountName : string;
  miniAccount : string;
  errorMessage : string='';
  scAccounts: any;
  constructor(private webService: CallBackEndService) {
    console.log("call function");


    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    //this.isLoad = true;
    //this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    //this.accountDigit = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    console.log('account if null selected : '+this.scAccounts[0]);
    this.miniAccount=  sessionStorage.getItem('miniAccounSelected');
    this.Accountbalance =sessionStorage.getItem('miniSelectedBalance');
    this.AccountName=sessionStorage.getItem('miniSelectedName');
    this.Accountmodule =sessionStorage.getItem('minidModuleType');
  //  this.AccountList = JSON.parse(sessionStorage.getItem('miniAcctlist'));
   // this.AccountList =sessionStorage.getItem('miniAcctlist');
    // this.miniAccount=this.AccountList[0];
    console.log("sco account iss " + this.scoAccounts);
   // console.log("accountlist " + this.AccountList);
    request.param1 = getHexAscii('',   sessionStorage.getItem('miniAccounSelected')+sessionStorage.getItem('storedUserName') );
    if(this.miniAccount==='' || this.miniAccount==undefined || this.miniAccount==null){
      request.param1 = getHexAscii('',this.scAccounts[0]+sessionStorage.getItem('storedUserName') );
      request.param2 = this.scAccounts[0];
     //if account not selected
    }else{
      request.param1 = getHexAscii('',   sessionStorage.getItem('miniAccounSelected')+sessionStorage.getItem('storedUserName') );
      request.param2 = this.miniAccount;
    }
   
    request.param3 =sessionStorage.getItem('storedUserName');

    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
    this.webService.getResponse(request, 'miniTransaction').subscribe((data: IbResponse) => {
      console.log("ffggg"+data.status );
      if (data !== null && data.status === 'S200' && data.param1 !== 'NORecord') {
        this.statementOfAccountList = data.param8;

        this.page1='show';
        //this.showLoanAmount ='Hide';
        console.log("message "+this.page1);
      }
      else
      {
        this.page1='show1';
        this.errorMessage="Record Not found";
        console.log("message "+this.page1+"error message "+this.errorMessage);
      }
    });
  }
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
  };
  ngOnInit() {
  
  }

  ScAcctInfo(){
    //this.scAccount=this.scAccounts[0];
    console.log("call service ");
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.miniAccount);
    request.param2 = this.miniAccount;
    this.webService.getResponse(request, 'miniTransaction').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200' && data.param1 !== 'NORecord') {
        this.statementOfAccountList = data.param8;
        this.AccountName = data.param5.fullName;
        this.Accountbalance = data.param5.clrBalanceStr;
        this.Accountmodule = data.param5.moduleType;
        this.page1='show';
        //this.showLoanAmount ='Hide';
        console.log("message "+this.page1);
      }
      else
      {
        //this.page1='show1';
        this.errorMessage=data.param1;
        console.log("message "+this.page1+"error message "+this.errorMessage);
      }
    });
  }

}




// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/mini-statment-of-account/mini-statment-of-account.component.ts